import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  landingPages: [],
  error: {},
}

export const fetchLandingPages = createAsyncThunk('landPageSlice/fetchLandPage', async (queyString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/landing-page${queyString ? queyString : ''}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const deleteLandingPage = createAsyncThunk('landPageSlice/deleteLandPage', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/landing-page/${id}`);
    console.log("response in del", response);
    response.data = id
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const createLandPage = createAsyncThunk('landPageSlice/createLandPage', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/landing-page', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const toggleActivation = createAsyncThunk('landPageSlice/toggleActivation', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/landing-page/${id}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const updateLandPage = createAsyncThunk('landPageSlice/updateLandPage', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/landing-page/${values?.id}`, values.formData);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const landPageSlice = createSlice({
  name: 'landPageSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetch landPage
    builder.addCase(fetchLandingPages.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchLandingPages.fulfilled, (state, action) => {
      state.landingPages = action.payload?.data?.results;
      state.loading = false;
    });
    builder.addCase(fetchLandingPages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    //create landingPages
    builder.addCase(createLandPage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createLandPage.fulfilled, (state, action) => {
      state.loading = false;
      state.landingPages = [action?.payload?.data.data, ...state.landingPages];
      if (action?.payload?.status == 201) {
        toast.success("LandPage created successfully")
      }
    });
    builder.addCase(createLandPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateLandPage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateLandPage.fulfilled, (state, action) => {
      state.loading = false;
      const landPage = action.payload?.data?.data;
      if (action.payload.status == 200) {
        state.landingPages = state.landingPages.map(page =>
          page.id === landPage.id ? landPage : page
        );
        toast.success("Landing Page updated Successfully !")
      }
    });
    builder.addCase(updateLandPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteLandingPage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteLandingPage.fulfilled, (state, action) => {
      state.loading = false;
      state.landingPages = state.landingPages.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success("LandPage deleted successfully")
      }
    });
    builder.addCase(deleteLandingPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // active incative landingPages
    builder.addCase(toggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivation.fulfilled, (state, action) => {
      const id = action?.payload?.data?.data?.id;
      state.landingPages = state.landingPages.map(page =>
        page.id === id ? action?.payload?.data?.data : page
      );
      state.loading = false;
      state.error = null;
      if (action?.payload?.status == 200) {
        toast.success("LandPage updated successfully")
      }
    });
    builder.addCase(toggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})


export default landPageSlice.reducer